import UseCase from "@domain/UseCase";
import { ImportJobStore } from "@domain/stores/ImportJobStore";

type Input = void;

type Output = void;

export class ClearImportJob implements UseCase<Input, Output> {
  constructor(private readonly importJobStore: ImportJobStore) {}

  execute() {
    return this.importJobStore.clear();
  }
}
